import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
// import Socials from "layouts/authentication/components/Socials";
// import Separator from "layouts/authentication/components/Separator";
import curved6 from "assets/images/curved-images/sign_up.jpg";
import { api } from "utils/Api";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const SignUp = () => {
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  // Email validation
  const isValidEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const payload = {
        name: `${first_name} ${last_name}`,
        description: "",
        frontend_metadata: {},
        backend_metadata: {},
        active: true,
        username: username,
        first_name: first_name,
        last_name: last_name,
        phone_number: phoneNumber,
        email: email,
        password: password,
      };
      
      const res = await api.user.createUser(payload);

      if (res?.id) {
        setMessage("Account created successfully!");
        navigate("/authentication/sign-in");
      } else {
        setMessage("Signup failed. Try again.");
      }
    } catch (err) {
      setMessage(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const isSubmitDisabled =
    isLoading ||
    !first_name ||
    !last_name ||
    !username ||
    !email ||
    !password ||
    !isValidEmail(email);

  return (
    <BasicLayout title="Welcome!" description="Create your account to get started." image={curved6}>
      <Card>
        <SoftBox p={3} mb={1} textAlign="center">
          <SoftTypography variant="h5" fontWeight="medium">
            Register Here
          </SoftTypography>
        </SoftBox>

        {/* <SoftBox mb={2}>
          <Socials />
        </SoftBox>

        <Separator /> */}

        <SoftBox pt={2} pb={3} px={3}>
          {message && <p>{message}</p>}

          <SoftBox component="form" role="form" onSubmit={handleSubmit}>
            <SoftBox mb={2}>
              <SoftInput
                placeholder="First Name"
                value={first_name}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </SoftBox>

            <SoftBox mb={2}>
              <SoftInput
                placeholder="Last Name"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
              />
            </SoftBox>

            <SoftBox mb={2}>
              <SoftInput
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </SoftBox>

            <SoftBox mb={2}>
              <SoftInput
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={email && !isValidEmail(email)}
                required
              />
              {email && !isValidEmail(email) && (
                <SoftTypography variant="caption" color="error">
                  Enter a valid email address
                </SoftTypography>
              )}
            </SoftBox>

            <SoftBox mb={2}>
              <SoftInput
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter your password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
                icon={{
                  component: (
                    <IconButton onClick={handleTogglePassword} size="small" tabIndex={-1}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                  direction: "right",
                }}
              />
            </SoftBox>

            <SoftBox mb={2}>
              <SoftInput
                type="text"
                placeholder="Phone Number (10 digits)"
                value={phoneNumber}
                inputProps={{ maxLength: 10 }}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // allow only numbers
                  setPhoneNumber(value);
                }}
                required
              />
            </SoftBox>

            <SoftBox mt={4} mb={1}>
              <SoftButton
                variant="gradient"
                color="dark"
                type="submit"
                fullWidth
                disabled={isSubmitDisabled}
              >
                {isLoading ? "Creating Account..." : "Sign Up"}
              </SoftButton>
            </SoftBox>

            <SoftBox mt={3} textAlign="center">
              <SoftTypography variant="button" color="text">
                Already have an account?{" "}
                <SoftTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="dark"
                  fontWeight="bold"
                  textGradient
                >
                  Sign in
                </SoftTypography>
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </Card>
    </BasicLayout>
  );
};

export default SignUp;
